export default {
  pdpwrapper: '',
  pdpwrapper: "PDP_Wrapper",
  hairAdvisor: 'hair-care-section fixed bottom-0 right-0 mr-10 mb-0 z-4 ',
  breadcrumbContainer:
    'breadcrumbContainer border-t-1 border-greyLine border-solid',
  headingBanner:
    'md:h-full lg:container mx-auto sm:min-h-100p sm:min-w-100p md:m-auto md:inset-x-0 flex flex-row flex-wrap commonBannerFive',
  mainproductImageWrapper:
    'product-image-wrapper-desktop w-full md:w-6/12 text-center',
  productImageWrapper: 'product-image-wrapper-mobile',
  maskImage: 'w-3/5',
  productImage: 'w-6/12',
  headingTextWrapper:
    'w-12/12 lg:w-6/12 py-0 md:py-25 md:pl-30 px-36 text-left md:pr-16 product-right-wrapper discover-button',
  topHeadingTextWrapper:
    'w-90p md:w-full z-1 relative pt-16 md:pt-3.5p md:pt-0',
  headingBannerFixed:
    ' mx-auto md:m-auto md:inset-x-0 md:flex flex-row flex-wrap hidden middle-header px-20 lg:px-0 bg-white-light',
  productRatingWrapper: 'flex items-center sm:w-8/12 md:w-8/12',
  productImageWrapperFixed:
    'md:w-2/12 flex bg-white-light bg-left-top bg-no-repeat items-center',
  headingTextWrapperFixed:
    'md:w-10/12 flex bg-white-light bg-left-top bg-no-repeat items-center',
  productImageFixed: 'md:w-3/12 md:ml-120',
  productTitleFixed: 'product-title-heading sm:w-4/12',
  productRatingFixed: 'pr-40 flex flex-row gap-5 item-center justify-center',
  count_individualrating: 'font-HelveticaNeueLight text-base text-grey',
  productCategory: '',
  productCategoryText:
    'text-4.5v md:text-18 md:leading-24 text-grey font-BebasNeueRegular tracking-wider2x md:tracking-wider product-sub-header pt-18',
  productTitle: 'relative',
  productTitleText:
    'block text-8v md:text-56 leading-none md:leading-50 text-black font-BebasNeueRegular tracking-wider3x md:tracking-wider1x pt-8 pb-12 pr-36 md:pr-0 md:pt-11 md:pb-22',
  productTitleTextSmall:
    'top-0 hidden text-black font-BebasNeueRegular pr-14p text-18 leading-20 tracking-wider8x pt-0 pb-5',
  totalreviewcount:
    'text-12 md:text-14 leading-44 text-grey font-HelveticaNeueLight tracking-wider6x',

  headingWrapper:
    'lg:w-container mx-auto sm:pl-20 sm:pr-20 lg:px-15 sm:text-32 text-36 font-BornreadyRegular mt-20 mb-30',
  carouselHeading:
    'w-full font-BornreadyRegular text-center md:text-left text-36 lg:text-40 pt-40',
  heading: 'leading-45 font-hairline lg:w-5/6',
  aboutSectionText:
    'text-36 leading-62 text-black font-BornreadyRegular tracking-normal font-normal pb-20 md:pb-34 pt-40 md:pt-46',
  productDescription:
    'product-description text-18 md:text-16 leading-28 text-black font-HelveticaNeueLight tracking-normal pb-50 md:pb-50',
  instagramSectionText: 'leading-45 font-hairline lg:w-5/6 mx-auto mb-45',
  readreviewSection: 'flex relative readreview-bg',
  readreviewWrapper:
    'w-full lg:w-innerContainer mx-auto sm:px-20 lg:px-0 pt-40 md:pt-40 sm:pb-0 sm:mb-10 md:mb-43',
  mainHeader: 'main-nav-header',
  mainNavHeaderWrapper: 'main-nav-header-wrapper',
  ingredient: {
    mainWrapper:
      'lg:max-w-container mx-auto sm:pl-20 sm:pr-20 lg:px-15 mt-63 md:mt-75 sm:mb-70 lg:mb-80 discover-button',
    containerWrapper: 'lg:w-innerContainer mx-auto',
    contentWrapper: 'contentWrapper inline-block discover-button',
    viewAllButtonWrapper:
      'viewAllButtonWrapper font-BebasNeueRegular text-18 leading-30 tracking-wider text-center discover-button',
    viewAllButton:
      'viewAllButton font-BebasNeueRegular text-18 leading-30 tracking-wider text-center gradient-line',
    viewAllButtonh4: 'font-normal',
    allIngredients: 'text-18 md:text-16 leading-28 text-black text-left font-HelveticaNeueLight tracking-normal pt-30',
    headingWrapper: 'text-36 font-BornreadyRegular discover-button',
    heading: 'leading-48 font-hairline lg:w-innerContainer mx-auto mb-22',
    dialog: {
      mainDiv:
        'bg-white mx-auto my-50 py-40 px-30 sm:w-11/12 md:w-1/2 relative h-80v overflow-scroll md:h-auto md:overflow-auto',
      title:
        'text-36 leading-48 text-black font-BornreadyRegular tracking-normal font-normal pb-0',
      closeButton:
        'absolute right-0 headclose text-40 font-HelveticaNeueLight mt-15 mr-30 top-0',
      closeSpan: 'closespan',
      linkContainer: 'buy-now-margin w-1/2 flex mb-15',
      content: 'flex flex-wrap content-start ',
      link: 'w-full flex justify-center px:15 event_buy_now_eretailer_exit',
      actionButtonContainer: 'text-center sm:mt-100 md:mt-0',
      actionButton:
        'text-center text-black py-7 px-10 mx-10 border-2 border-black border-solid;',
      actionSpan: 'font-BebasNeueRegular text-16 leading-24',
      contentWrapper: 'contentWrapper',
      titleMessage: 'titleMessage',
      message:
        'text-16 leading-28 text-black font-HelveticaNeueLight tracking-normal',
    },
  },
  stillConfused: {
    containerWrapper:
      'lg:w-innerContainer mx-auto font-HelveticaNeueLight mb-70 sm:text-18 lg:text-16 sm:px-35 lg:px-0 relative',
    leftWrapper: 'leftWrapper',
    rightWrapper: 'rightWrapper',
  },
  fromOurInstagram: {
    mainWrapper:
      'our-instagram-stories-section sm:w-full md:w-11/12 lg:max-w-container mx-auto sm:pl-20 sm:pr-20 md:px-15 mt-20 sm:my-70 md:my-80',
    headingWrapper: 'text-36 font-BornreadyRegular',
    heading: 'leading-48 font-hairline lg:w-5/6 mx-auto mb-45',
  },
  moreOnThisTopic: {
    mainWrapper:
      'more-on-this-topic-section sm:w-full md:w-11/12 md:max-w-container mx-auto sm:pl-20 sm:pr-20 md:px-15 sm:mb-70 md:mb-80',
    headingWrapper: 'text-36 font-BornreadyRegular',
    heading: 'leading-48 font-hairline lg:w-5/6 mx-auto mb-45',
  },
  relatedProduct: {
    mainWrapper:
      'related-product-section sm:w-full md:w-11/12 lg:max-w-container mx-auto sm:pl-20 sm:pr-20 md:px-15 sm:my-70 md:mt-102 md:mb-80',
    headingWrapper: 'text-36 font-BornreadyRegular',
    heading: 'leading-48 font-hairline lg:w-5/6 mx-auto mb-30 lg:mt-20',
  },
  socialShare: 'social-share-section',
  headingBannerMainParent: 'pb-0 md:pb-25 pt-0 commonBannerStyle',
  headingBannerMainImg: 'mx-auto',
  headingBannerBtnParent: 'w-4/12',
  headingBannerMainBtn: 'try-now-btn text-center mx-auto z-1 bg-white-light',
  headingBannerProdImg: 'mx-auto sm:h-auto md:h-auto',
  headingBannerProdMobImg: 'mx-auto sm:h-40vh md:h-auto',
  headingBannerBuyNowBtn: 'try-now-btn z-1 bg-white',
  prodDetailsbuyNowBtnWrapper: 'buyNowBtnWrapper productBuyNowBtnWrapper',
  prodDetailsbuyNowBtn:
    'w-full try-now-btn text-center z-1 bottom-0 fixed bg-white md:hidden block child-m-0 p-10',
};